export default __webpack_public_path__ + "static/SR USA - GE-GMO - Statement-e8ded57b2524aa49926a52aac51a768a.pdf";